import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    backgroundColor: theme.palette.white,
    flex: 1,
    height: '100%',
    width: '100%',
    margin: '0 auto',
    position: 'relative',
    padding: '0 1rem 2rem',
    selectors: {
      [layout.breakpoints.min.lg]: {
        maxWidth: `calc(${pxToRem(910)} + 4rem)`,
        paddingLeft: '2rem',
        paddingRight: '2rem',
      },
      [layout.breakpoints.min.xxl]: {
        maxWidth: `calc(${pxToRem(1074)} + 4rem)`,
      },
    },
  },
  fullWidth: {
    selectors: {
      [layout.breakpoints.min.lg]: {
        maxWidth: '100%',
      },
    },
  },
});
